import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey-lighten-1" }
const _hoisted_2 = {
  key: 2,
  class: "d-flex flex-column ga-3 w-100"
}
const _hoisted_3 = { class: "w-100" }

import { ref, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

import TruckMapView from '@/components/Cementera/TruckMapView.vue';
import StatusSummaryBottomView from '@/components/Cementera/StatusSummaryBottomView.vue';
import DialogComponent from '@/components/SmartLink/dialog/dialogComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

import { getAllLatencyData } from '@/services/Smartlink/KPI';
import { getOperabilityLastDayTopology } from '@/services/Smartlink/Topology';
import { getAllStatusData } from '@/services/Smartlink/Principal';

import { LATENCY } from '@/interfaces/SmartLink/Topology';
import { OPERABILITY } from '@/interfaces/SmartLink/Equipos';
import { getDeviceModel, extractNumberFromName } from '@/utils/SmartLink/device';
import { getRajantGPS } from "@/services/Smartlink/Drive";
import { getAllDataLatLngSM } from "@/services/Smartlink/Map";


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const { t } = useI18n();

const rawData = ref<LATENCY[]>([]);
const getAllIEOByIP = ref<OPERABILITY[]>([]);

const statusCounts = ref({
    distri: { ok: 0, alarm: 0, alert: 0, down: 0 },
    acceso: { ok: 0, alarm: 0, alert: 0, down: 0 },
    client: { ok: 0, alarm: 0, alert: 0, down: 0 }
});

const showError = ref(false);
const showCircle = ref(true);
const loadingRefresh = ref(false);
let timerId: ReturnType<typeof setInterval> | null = null;

const dialog = ref(false);
const selectedIp = ref('');
const selectedName = ref('');
const selectedType = ref('');
const selectedModel = ref('');

function showDialogWithType(item: LATENCY) {
    selectedIp.value = item.ip;
    selectedName.value = item.name;
    selectedType.value = item.tipo;
    selectedModel.value = getDeviceModel(item.anotacion);
    dialog.value = true;
}

async function fetchDashboardData(isManualRefresh = false) {
    if (isManualRefresh) loadingRefresh.value = true;

    try {
        const opRes = await getOperabilityLastDayTopology();
        if (opRes?.status === 200) getAllIEOByIP.value = opRes.data || [];

        const [responseLat, responseGps, responseSm, responseStatus] = await Promise.all([
            getAllLatencyData(),
            getRajantGPS(),
            getAllDataLatLngSM(),
            getAllStatusData()
        ]);

        if (responseStatus?.status === 200 && responseStatus.data?.countEquipData) {
            statusCounts.value = responseStatus.data.countEquipData;
        }

        showError.value = !responseLat?.showGraphs;
        showCircle.value = false;

        if (responseLat?.status === 200) {
            const latencyData = responseLat.data || [];
            const gpsRajantData = responseGps?.status === 200 ? responseGps.data : [];
            const smData = responseSm?.status === 200 ? responseSm.data : [];

            const rajantGpsMap = new Map<string, { latitud: number; longitud: number }>();
            const apMovilGpsMapById = new Map<string, { latitud: number; longitud: number }>();

            gpsRajantData.forEach((g: any) => {
                if (g.ip && g.latitud && g.longitud) {
                    rajantGpsMap.set(g.ip, { latitud: g.latitud, longitud: g.longitud });

                    const isAcceso = g.subtipo?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === "acceso";
                    const isApMovil = g.tipo?.toLowerCase().replace(/\s+/g, "") === "apmovil";

                    if (isAcceso && isApMovil) {
                        const idNum = extractNumberFromName(g.name, "RAJANT");
                        if (idNum) {
                            apMovilGpsMapById.set(idNum, { latitud: g.latitud, longitud: g.longitud });
                        }
                    }
                }
            });

            const smGpsMap = new Map<string, any>();
            smData.forEach((s: any) => {
                if (s.ip) smGpsMap.set(s.ip, s);
            });

            const extractGpsIp = (anotacion: any): string => {
                if (!anotacion) return '';
                try {
                    const parsed = typeof anotacion === 'string' ? JSON.parse(anotacion) : anotacion;
                    return parsed?.gps || '';
                } catch {
                    const match = String(anotacion).match(/gps:\s*["']?([^]+)["']?/);
                    return match ? match[1].trim() : '';
                }
            };

            rawData.value = latencyData.map((item: LATENCY) => {
                let latitud = 0;
                let longitud = 0;

                const isSubtipoDistribucion = item.subtipo?.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") === 'distribución';
                const smInfo = smGpsMap.get(item.ip);

                if (isSubtipoDistribucion || smInfo) {
                    const targetGpsIp = extractGpsIp(item.anotacion) || extractGpsIp(smInfo?.anotacion);

                    if (targetGpsIp && rajantGpsMap.has(targetGpsIp)) {
                        const linkedGps = rajantGpsMap.get(targetGpsIp)!;
                        latitud = linkedGps.latitud;
                        longitud = linkedGps.longitud;
                    } else {
                        const smIdNum = extractNumberFromName(item.name, "PMPSM");
                        if (smIdNum && apMovilGpsMapById.has(smIdNum)) {
                            const linkedGps = apMovilGpsMapById.get(smIdNum)!;
                            latitud = linkedGps.latitud;
                            longitud = linkedGps.longitud;
                        }
                    }
                } else {
                    const rajantGps = rajantGpsMap.get(item.ip);
                    if (rajantGps) {
                        latitud = rajantGps.latitud;
                        longitud = rajantGps.longitud;
                    }
                }

                const gpsInfo = gpsRajantData.find((g: any) => g.ip === item.ip);

                return {
                    ...item,
                    latitud,
                    longitud,
                    tipo: item.tipo || gpsInfo?.tipo || smInfo?.tipo || '',
                    subtipo: item.subtipo || gpsInfo?.subtipo || ''
                };
            });
        }
    } catch (err) {
        console.error("Error al refrescar datos del Dashboard:", err);
    } finally {
        loadingRefresh.value = false;
    }
}

onMounted(() => {
    fetchDashboardData();
    timerId = setInterval(() => fetchDashboardData(), 60000);
});

onUnmounted(() => {
    if (timerId) clearInterval(timerId);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "defaultCard pa-3",
    color: "bgtopology",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "ma-0 align-center justify-space-between mb-3 ga-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "auto",
            class: "pa-0 d-flex align-center ga-2"
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "titlePages text-truncate" }, "Dashboard Cementera - Vista General", -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-refresh",
                variant: "tonal",
                color: "primary",
                size: "x-small",
                loading: loadingRefresh.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchDashboardData(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    class: _normalizeClass({ 'spin-icon': loadingRefresh.value })
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-refresh", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_tooltip, {
                    activator: "parent",
                    location: "bottom"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Actualizar datos", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (showCircle.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "text-center py-8",
            color: "transparent"
          }, {
            default: _withCtx(() => [
              _createVNode(Prog_circular)
            ]),
            _: 1
          }))
        : (showError.value)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              class: "ma-0 py-4 justify-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)('noInformation')), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_row, { class: "ma-0 align-stretch ga-0 w-100" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    class: "pa-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TruckMapView, {
                        trucks: rawData.value,
                        "operability-data": getAllIEOByIP.value,
                        onSelectDevice: showDialogWithType
                      }, null, 8, ["trucks", "operability-data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(StatusSummaryBottomView, { "status-counts": statusCounts.value }, null, 8, ["status-counts"])
              ])
            ])),
      _createVNode(_component_v_dialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
        width: "85%"
      }, {
        default: _withCtx(() => [
          (dialog.value)
            ? (_openBlock(), _createBlock(DialogComponent, {
                key: 0,
                ip: selectedIp.value,
                typeSel: selectedType.value,
                name: selectedName.value,
                model: selectedModel.value,
                onDialog: _cache[1] || (_cache[1] = ($event: any) => (dialog.value = false))
              }, null, 8, ["ip", "typeSel", "name", "model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})